import React from 'react';

/** Big centred icon + a line or two — empty lists, "nothing found", loading. */
export function EmptyState({ icon, title, sub, children }) {
  return (
    <div className="do-empty">
      <span className="do-empty__icon">{icon}</span>
      {title != null && <p className="do-empty__title">{title}</p>}
      {sub != null && <p className="do-empty__sub">{sub}</p>}
      {children}
    </div>
  );
}

/** The loading state every tab shows while its data arrives. */
export const Loading = ({ label }) => (
  <div className="do-empty"><span className="do-empty__icon">⏳</span><p>{label}</p></div>
);
